module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAALRJREFUKFPtkmENwjAUhL9zMBQADiZhDkACKAAJWEABOAEJSBgOcHDkLR3pRglL+MtL+qOvvXvt3YkfSmOs7RpYFTiPkh55vwS+AocROAgrSYN+ESypycG2Y9/8wdAJZnsN7JJItaRZQbAT0Kb+VlLbgyvgDMyBOLgV/I8BQRB+d5YNrLK9BzaxcoKsv5cUOeiq5PMiveISU9K0ewTna8J61k/T3uJpO54a/5lay5dgUxHje09K7mIQ8kBquQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_t1_on.png
// module id = bFoJ
// module chunks = 85